<template>
  <section class="asuransi-container" data-aos="fade-left" data-aos-delay="300">
    <div class="container">
      <div class="section-title text-center">
        <div class="row">
          <div class="col-md-12 col-md-offset-2">
            <h2 class="mt-0 line-height-1 text-uppercase">
              Video
              <span class="text-theme-colored">RSUII</span>
            </h2>
          </div>
        </div>
      </div>
      <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
      <div v-else-if="videos.length < 1" class="alert alert-danger">No data</div>
      <carousel
        v-else
        :autoplay="true"
        :nav="false"
        :items="(videos.length > 2) ? 2 : videos.length"
        :loop="false"
        :dots="false"
        :responsive="{
				  	1024:{items:2},
				  	639:{items:2},
				  	0:{items:1}
				  }"
      >
        <div :key="'video-'+item.id" v-for="item in videos" class="col-md-12">
          <iframe
            style="border:none; border-radius: 5px"
            width="100%"
            height="315"
            :src="'https://www.youtube.com/embed/'+item.content"
          ></iframe>
          <h5 class="mt-15 mb-10 text-center">{{ item.title }}</h5>
        </div>
      </carousel>
    </div>
  </section>
</template>

<script>
import carousel from "vue-owl-carousel";
import api from "../../services/api";

export default {
  components: { carousel },
  data() {
    return {
      show_loading: true,
      videos: [],
    };
  },
  mounted() {
    this.getVideos();
  },
  methods: {
    getVideos() {
      api
        .post(api.route.get.videos)
        .then((res) => {
          let status = res.status;
          if (status) {
            this.show_loading = false;
            this.videos = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/home/HomeVideo.vue